import type { CreateTaskRequest, UpdateTaskRequest } from '../generated/dtos.gen';
import { TaskSource } from '../generated/enums.gen';

export function createTaskRequest(
  fields: Pick<CreateTaskRequest, 'title'> & Partial<CreateTaskRequest>,
): CreateTaskRequest {
  return {
    description: null,
    source: TaskSource.ManagerAssigned,
    dueDate: null,
    dueTime: null,
    durationMinutes: 60,
    assignedToId: null,
    shiftId: null,
    relatedVoterId: null,
    categoryId: null,
    actionUrl: null,
    ...fields,
  };
}

export function updateTaskRequest(fields: Partial<UpdateTaskRequest>): UpdateTaskRequest {
  return {
    title: null,
    description: null,
    dueDate: null,
    clearDueDate: false,
    dueTime: null,
    clearDueTime: false,
    durationMinutes: null,
    assignedToId: null,
    clearAssignee: false,
    shiftId: null,
    relatedVoterId: null,
    categoryId: null,
    actionUrl: null,
    ...fields,
  };
}
